export const getUnzoomedRect = (element: HTMLElement, zoom = 1) => {
  const rect = JSON.parse(JSON.stringify(element.getBoundingClientRect()));
  if (zoom === 1) {
    return rect;
  }

  const zoomedEntries = Object.entries(rect)
    .map(([key, value]) => typeof value === 'number' ? [key, value / zoom] : [key, value]);

  return Object.fromEntries(zoomedEntries);
};

export const scrollIntoView = (
  target: HTMLElement,
  scrollableContainer: HTMLElement,
  scrollOptions: ScrollIntoViewOptions = {
    block: 'center',
    behavior: 'auto',
  },
  zoom = 1,
) => {
  const targetRect = getUnzoomedRect(target, zoom);
  const ancestorRect = getUnzoomedRect(scrollableContainer, zoom);
  const offsetTop = targetRect.top - ancestorRect.top + scrollableContainer.scrollTop;

  const { block } = scrollOptions;

  let scrollTo;
  // Different position calculation are written by GPT, may not work :)
  switch (block) {
    case 'start':
      scrollTo = offsetTop;
      break;
    case 'end':
      scrollTo = offsetTop - ancestorRect.height + targetRect.height;
      break;
    case 'nearest':
      // Scroll as little as possible:
      if (offsetTop < scrollableContainer.scrollTop) {
        scrollTo = offsetTop;
      } else if (offsetTop + targetRect.height > scrollableContainer.scrollTop + ancestorRect.height) {
        scrollTo = offsetTop - ancestorRect.height + targetRect.height;
      } else {
        scrollTo = scrollableContainer.scrollTop; // no scroll needed
      }
      break;
    case 'center':
    default:
      scrollTo = offsetTop - (ancestorRect.height / 2) + (targetRect.height / 2);
      break;
  }

  scrollableContainer.scrollTo({
    top: scrollTo,
    behavior: scrollOptions.behavior,
  });
};
